/** Cores idênticas às CSS vars do site (formato rgb) */
export const CONECTAR_PRIMARY = '#0E7BEF';

/**
 * Paleta para gráficos com várias séries (ex.: Professor vs. Aluno vs.
 * Outros). Série 1 é sempre a cor da marca — as demais são acentos que
 * diferenciam bem tanto no claro quanto no escuro. Recharts recebe cor
 * literal nos props (fill/stroke), por isso são hex fixos e não CSS vars.
 */
const CHART_ACCENTS = ['#0EA5E9', '#F59E0B', '#10B981', '#8B5CF6'] as const;
export const CHART_COLORS = [CONECTAR_PRIMARY, ...CHART_ACCENTS] as const;

export function getChartTheme(isDark: boolean) {
  if (isDark) {
    return {
      primary: CONECTAR_PRIMARY,
      grid: 'rgb(51 65 85)',
      axis: 'rgb(148 163 184)',
      tooltipBg: 'rgb(30 41 59)',
      tooltipBorder: 'rgb(51 65 85)',
      tooltipText: 'rgb(248 250 252)',
      cursor: 'rgb(51 65 85 / 0.35)',
    };
  }

  return {
    primary: CONECTAR_PRIMARY,
    grid: 'rgb(226 232 240)',
    axis: 'rgb(100 116 139)',
    tooltipBg: 'rgb(255 255 255)',
    tooltipBorder: 'rgb(226 232 240)',
    tooltipText: 'rgb(15 23 42)',
    cursor: 'rgb(248 250 252 / 0.8)',
  };
}
